const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时更新',
    desc: '7×24小时追踪全网热点，热门事件1小时内上线视频合集，确保你第一时间吃到最新鲜的瓜。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量内容',
    desc: '收录超过10万条吃瓜短视频与直播回放，覆盖娱乐圈、网红圈、社会热点等多元领域，总有一条是你想吃的。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '支持Web端、iOS APP和Android APP多端观看，数据实时同步，随时随地畅享吃瓜乐趣。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '内容精选',
    desc: '专业编辑团队人工筛选，去伪存真，确保每一条内容都经过验证，拒绝虚假信息，吃瓜更放心。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            ✨ 为什么选择我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            51今日吃瓜的核心优势，让吃瓜体验更上一层楼
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center transition-all duration-300 hover:border-primary-200/50"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}